"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushEventDataMsg = exports.PushInteractionDataMsg = void 0;
const router_1 = require("@keplr-wallet/router");
const constants_1 = require("./constants");
class PushInteractionDataMsg extends router_1.Message {
    constructor(data) {
        super();
        this.data = data;
    }
    static type() {
        return "push-interaction-data";
    }
    validateBasic() {
        if (!this.data.type) {
            throw new router_1.KeplrError("interaction", 101, "Type should not be empty");
        }
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return PushInteractionDataMsg.type();
    }
}
exports.PushInteractionDataMsg = PushInteractionDataMsg;
class PushEventDataMsg extends router_1.Message {
    constructor(data) {
        super();
        this.data = data;
    }
    static type() {
        return "push-event-data";
    }
    validateBasic() {
        if (!this.data.type) {
            throw new router_1.KeplrError("interaction", 101, "Type should not be empty");
        }
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return PushEventDataMsg.type();
    }
}
exports.PushEventDataMsg = PushEventDataMsg;
//# sourceMappingURL=messages.js.map